<template>
  <router-link class="btn btn-link py-0 btn-back" :to="to" exact>
    <font-awesome-icon icon="arrow-left" size="lg"/>
  </router-link>
</template>
<script>
  export default {
    props: ['to'],
    data () {
      return {}
    },
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/back-button.vue